export default "__VITE_ASSET__Bs0szikH__"